require('./style.scss')
angular = require('angular')
pkg = angular.module('cdms.device.terminal', [require('angular-ui-router')])  
  .config ($stateProvider) ->
    $stateProvider
      .state 'devices.terminal',
        url: "/:_id/terminal"       
        authenicate: true   
        views:
          "@":             
            template: require('./index.pug') 
            controller: 'DeviceTerminalCtrl' 
  .controller('DeviceTerminalCtrl', require("./controller"))
  .directive('terminal', require("./terminal"))

module.exports = pkg.name




// WEBPACK FOOTER //
// ./src/component/device/terminal/index.coffee